import _ from 'lodash';
import { NotificationActionTypes } from './actions.notifications.types';

export default function notifications(state = [], action) {
  switch (action.type) {
    case NotificationActionTypes.CREATE_NOTIFICATION:
      return [
        ...state,
        {...action.notification}
      ];
    case NotificationActionTypes.DISMISS_NOTIFICATION:
      return _.without(state, action.notification);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/common/redux/reducers.notifications.js